<template>
    <th @click="sortBy(keyName)" :class="{'font-extrabold' : sortKey === keyName }" scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider break-words">
        <div class="cursor-pointer flex items-center justify-between">
            <span class="whitespace-nowrap" v-html="formattedDisplay"></span>
            <span v-if="sortKey === keyName">
                <svg :class="{'transform rotate-180' : sortOrder === 'asc' }" class="w-4 h-4 ml-1 transition duration-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 4h13M3 8h9m-9 4h9m5-4v12m0 0l-4-4m4 4l4-4"></path></svg>
            </span>
        </div>
    </th>
</template>

<script>
    export default {
        props: {
            display: {
                required: true,
                type: String
            },
            keyName: {
                required: true,
                type: String
            },
            sortKey: {
                required: true,
                type: String
            },
            sortOrder: {
                required: true,
                type: String
            }
        },
        computed: {
            formattedDisplay() {
                return this.display.replace(/\s/g, '<br />')
            }
        },
        methods: {
            sortBy(keyName) {
                this.$eventBus.$emit('sortBy', keyName)
            }
        }
    }
</script>
